import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";
import { track } from "@/lib/track";

const CartContext = createContext(null);
const KEY = "pettok_cart";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch {
      return [];
    }
  });
  const [code, setCode] = useState(() => localStorage.getItem(`${KEY}_code`) || "");

  useEffect(() => localStorage.setItem(KEY, JSON.stringify(items)), [items]);
  useEffect(() => localStorage.setItem(`${KEY}_code`, code), [code]);

  const add = (product, qty = 1, extra = {}) => {
    setItems((prev) => {
      const found = prev.find((i) => i.slug === product.slug);
      if (found) return prev.map((i) => (i.slug === product.slug ? { ...i, qty: Math.min(50, i.qty + qty) } : i));
      return [...prev, { slug: product.slug, name: product.name, price: product.price, image: product.image, qty }];
    });
    toast.success(`${product.name} added to cart`);
    window.dispatchEvent(new Event("pettok:added"));
    track("add_to_cart", { slug: product.slug, qty, value: product.price * qty, ...extra });
  };
  const addMany = (products, label, extra = {}) => {
    setItems((prev) => products.reduce((list, p) => {
      const found = list.find((i) => i.slug === p.slug);
      return found ? list.map((i) => (i.slug === p.slug ? { ...i, qty: Math.min(50, i.qty + 1) } : i)) : [...list, { slug: p.slug, name: p.name, price: p.price, image: p.image, qty: 1 }];
    }, prev));
    toast.success(`${label} added to cart`);
    window.dispatchEvent(new Event("pettok:added"));
    track("add_to_cart", { slugs: products.map((p) => p.slug), qty: products.length, value: products.reduce((n, p) => n + p.price, 0), ...extra });
  };
  const setQty = (slug, qty) => setItems((prev) => (qty < 1 ? prev.filter((i) => i.slug !== slug) : prev.map((i) => (i.slug === slug ? { ...i, qty: Math.min(50, qty) } : i))));
  const clear = () => setItems([]);
  const restore = (lines) => setItems((prev) => {
    const saved = lines.map(({ slug, name, price, image, qty }) => ({ slug, name, price, image, qty }));
    return [...prev.filter((i) => !saved.some((s) => s.slug === i.slug)), ...saved];
  });
  const count = items.reduce((n, i) => n + i.qty, 0);

  return <CartContext.Provider value={{ items, add, addMany, setQty, clear, restore, count, code, setCode }}>{children}</CartContext.Provider>;
};

export const useCart = () => useContext(CartContext);
